export default "__VITE_ASSET__BOOX5WFa__"